module.exports = __webpack_public_path__ + "img/esic_logo.8bb1f375.png";